import { useEffect } from "react";
import Cookies from "js-cookie";

import { saveThemeCookie } from "../lib/manageCookies";

export const useThemeCookie = (setDark: SetBoolean) => {
  useEffect(() => {
    const theme = Cookies.get("theme");
    const savedTheme = Boolean(theme);

    const prefersDark = savedTheme
      ? theme === "Dark"
        ? true
        : false
      : window.matchMedia("(prefers-color-scheme: dark)").matches;

    if (!savedTheme) {
      saveThemeCookie(prefersDark);
    }

    setDark(prefersDark);
  }, [setDark]);
};
